import BaseRequestSearchPageMixin from "@/modules/core/request/protected/BaseRequestSearchPageMixin";
import SearchParametersEditor from "./CreditAssignmentRequestSearchParametersEditor";
import service from "./CreditAssignmentRequestService";

export default {
  mixins: [BaseRequestSearchPageMixin],

  components: {
    SearchParametersEditor
  },

  props: {
    columns: {
      default() {
        return [
          {
            key: "status",
            label: this.$t("request.fields.status"),
            sortBy: "status",
            value: ({ row }) => this.$t("requestStatus." + row.status),
            onClick: ({ row }) => {
              this.$router.push({
                name: "CreditAssignmentRequest",
                params: { id: row.id }
              });
            },
            styleClass: ({ row }) => {
              if (!row) {
                return "col"; // Header
              } else {
                return "col bg-" + this.variantFor(row.status);
              }
            }
          },
          /*
          {
            key: 'exceedingDays',
            label: this.$t('request.fields.exceedingDays'),
            styleClass: ({ row }) => {
              if (!row) {
                return 'col'; // Header
              } else {
                return row.exceedingDays > 0 ? 'col bg-danger' : 'col';
              }
            }
          },
          */
          {
            key: "numberOfFiles",
            label: this.$t("request.fields.numberOfFiles"),
            sortBy: "numberOfFiles"
          },
          {
            key: "amount",
            label: this.$t("creditAssignmentRequest.fields.amount"),
            sortBy: "amount",
            value: ({ row }) => "€ " + this.$number2text(row.amount)
          },
          {
            key: "title",
            label: this.$t("creditAssignmentRequest.fields.title"),
            sortBy: "title"
          },
          {
            key: "customer",
            label: this.$t("request.fields.customer"),
            sortBy: "customer.companyName",
            value: ({ row }) => row.customer.companyName
          },
          /*
          {
            key: 'lastModified',
            label: this.$t('common.lastModified'),
            sortBy: 'lastModified'
          },
          */
          {
            key: "actions",
            label: this.$t("common.actions"),
            type: "actions",
            //showHeader: false,
            //styleClass: 'col-12 text-right',
            styleClass: "col text-right",
            actions: [
              {
                label: this.$t("common.view"),
                icon: "eye",
                variant: "success",
                show: ({ row }) =>
                  row.permissions.view && !row.permissions.saveInitial,
                action: ({ row }) => {
                  this.$router.push({
                    name: this.requestPage(),
                    params: { id: row.id }
                  });
                }
              },
              {
                label: this.$t("common.edit"),
                icon: "edit",
                variant: "warning",
                show: ({ row }) => row.permissions.saveInitial,
                action: ({ row }) => {
                  this.$router.push({
                    name: this.requestPage(),
                    params: { id: row.id },
                    query: { edit: true }
                  });
                }
              },
              {
                label: this.$t("common.assign"),
                icon: "check",
                variant: "primary",
                show: ({ row }) => row.permissions.assign,
                action: ({ row }) => {
                  this.$router.push({
                    name: this.evaluationPage(),
                    params: { id: row.id }
                  });
                }
              },
              {
                label: this.$t("common.remove"),
                icon: "times",
                variant: "danger",
                show: ({ row }) => row.permissions.delete,
                action: ({ row }) => {
                  this.remove(row);
                }
              }
            ]
          }
        ];
      }
    }
  },

  data() {
    return {
      sort: {
        sort: "title",
        order: "ASC"
      }
    };
  },

  methods: {
    getService() {
      return service;
    }
  }
};
